import React, { useState } from "react";
import {
  DialogContent,
  DialogActions,
  Button,
  TextField,
  List,
  ListItem,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import FormTextField from "../ui/FormTextField";
import { SecondaryButton } from "../ui/SecondaryButton";
import { PrimaryButton } from "../ui/PrimaryButton";

function VariationsModal({
  open,
  onClose,
  attributes,
  setAttributes,
  attrIndex,
}) {
  const [newVariation, setNewVariation] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [editValue, setEditValue] = useState("");

  if (attrIndex === null || attrIndex >= attributes.length) return null;

  const attribute = attributes[attrIndex];

  const handleAddVariation = () => {
    if (!newVariation.trim()) return;
    setAttributes((prev) => {
      const copy = [...prev];
      copy[attrIndex].variations.push(newVariation.trim());
      return copy;
    });
    setNewVariation("");
  };

  const handleDeleteVariation = (index) => {
    setAttributes((prev) => {
      const copy = [...prev];
      copy[attrIndex].variations.splice(index, 1);
      return copy;
    });
    // Если удаляем редактируемый элемент — сбрасываем режим редактирования
    if (editIndex === index) {
      setEditIndex(null);
      setEditValue("");
    }
  };

  const startEditing = (index) => {
    setEditIndex(index);
    setEditValue(attribute.variations[index]);
  };

  const cancelEditing = () => {
    setEditIndex(null);
    setEditValue("");
  };

  const saveEditing = () => {
    if (!editValue.trim()) return;
    setAttributes((prev) => {
      const copy = [...prev];
      copy[attrIndex].variations[editIndex] = editValue.trim();
      return copy;
    });
    setEditIndex(null);
    setEditValue("");
  };

  return (
    <>
      <Typography variant="h6" sx={{ mb: "10px" }}>
        Додавання атрибуту
      </Typography>
      <Box sx={{ mb: "20px" }}>
        <FormTextField
          label="Назва атрибута"
          value={attribute.name}
          // onChange={(e) => setNewAttrName(e.target.value)}
          fullWidth
          margin="normal"
          InputProps={{
            readOnly: true,
          }}
        />

        <Box sx={{ width: "100%" }}>
          <Typography>Нова варіація</Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <TextField
              fullWidth
              value={newVariation}
              onChange={(e) => setNewVariation(e.target.value)}
              margin="normal"
              size="small"
              sx={{ mt: 1 }}
            />
            <IconButton
              className="bg-f6f7f9"
              sx={{ borderRadius: "10px", height: "35px" }}
              color="primary"
              onClick={handleAddVariation}
              aria-label="Додати варіацію"
            >
              <AddIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>

      <DialogActions sx={{ p: 0, justifyContent: "start" }}>
        <PrimaryButton onClick={onClose}>Закрити</PrimaryButton>
        {/* <SecondaryButton onClick={onClose}></SecondaryButton> */}
      </DialogActions>

      <List sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {attribute.variations.map((variation, i) => (
          <ListItem
            className={`border-bottom ${i === 0 ? "border-top" : ""}`}
            key={i}
            sx={{
              display: "flex",

              justifyContent: "space-between",
              cursor: "pointer",
              borderRadius: "15px",
              overflow: "hidden",
              "& .MuiListItemButton-root": {
                borderRadius: "15px",
              },
            }}
            style={{ marginTop: "10px" }}
          >
            {editIndex === i ? (
              <>
                <TextField
                  size="small"
                  value={editValue}
                  onChange={(e) => setEditValue(e.target.value)}
                  sx={{ flexGrow: 1, mr: 2 }}
                />
                <IconButton
                  color="primary"
                  onClick={saveEditing}
                  aria-label="Зберегти"
                >
                  <SaveIcon />
                </IconButton>
                <Button onClick={cancelEditing} sx={{ ml: 1 }}>
                  Відмінити
                </Button>
              </>
            ) : (
              <>
                <Box sx={{ flexGrow: 1 }}>{variation}</Box>
                <IconButton
                  color="error"
                  onClick={() => handleDeleteVariation(i)}
                  aria-label="Видалити"
                >
                  <DeleteIcon />
                </IconButton>
                <IconButton
                  color="primary"
                  onClick={() => startEditing(i)}
                  aria-label="Редагувати"
                >
                  <EditIcon />
                </IconButton>
              </>
            )}
          </ListItem>
        ))}
      </List>
    </>
  );
}

export default VariationsModal;
